<i class="icon star" title="These options require a Persistence (€8) subscription or Prepaid plan to use">star</i>

<style>
.star {
	font-size: 1em;
	color: #BF00FF;
}
</style>
